import { Injectable, signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import {
  CompareMode,
  IPerioSettings,
  SwitchDirection,
  SwitchPattern,
  TableStyle,
} from '@principle-theorem/principle-core/interfaces';
import { isEqual } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class PerioSettingsService {
  autoSwitchCells = signal<boolean>(false);
  switchPattern = signal<SwitchPattern>(SwitchPattern.Zigzag);
  direction = signal<SwitchDirection>(SwitchDirection.Default);
  tableStyle = signal<TableStyle>(TableStyle.Table);
  isStyleTable = signal<boolean>(true);
  isStyleBorderless = signal<boolean>(false);

  compareMode = signal<CompareMode | undefined>(undefined, { equal: isEqual });
  hideCurrentValues = signal<boolean>(false, { equal: isEqual });
  readonly isOverlayMode = signal<boolean>(false, { equal: isEqual });
  readonly isDifferenceMode = signal<boolean>(false, { equal: isEqual });

  constructor() {
    toObservable(this.compareMode)
      .pipe(takeUntilDestroyed())
      .subscribe((mode) => {
        if (mode === undefined) {
          this.resetCompareModes();
          return;
        }
        if (mode !== CompareMode.Overlay) {
          this.hideCurrentValues.set(false);
        }
        this.isOverlayMode.set(mode === CompareMode.Overlay);
        this.isDifferenceMode.set(mode === CompareMode.Difference);
      });
  }

  applyStafferSettings(settings: IPerioSettings | undefined): void {
    if (!settings) {
      return;
    }
    this.autoSwitchCells.set(settings.autoSwitchCells);
    this.switchPattern.set(settings.switchPattern);
    this.direction.set(settings.switchDirection);
    this.tableStyle.set(settings.tableStyle);
    this.isStyleTable.set(settings.tableStyle === TableStyle.Table);
    this.isStyleBorderless.set(settings.tableStyle === TableStyle.Borderless);
  }

  private resetCompareModes(): void {
    this.compareMode.set(undefined);
    this.hideCurrentValues.set(false);
    this.isOverlayMode.set(false);
    this.isDifferenceMode.set(false);
  }
}
